module.exports = __webpack_public_path__ + "static/media/IMG-3.91da4b5c.jpg";